import { render, staticRenderFns } from "./DiagnoseTable.vue?vue&type=template&id=9a08d580&scoped=true"
import script from "./DiagnoseTable.vue?vue&type=script&lang=js"
export * from "./DiagnoseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a08d580",
  null
  
)

export default component.exports